const getEnvFromLocation = function () {
  const locationHostname = window.location.hostname

  if (locationHostname === 'localhost') {
    return 'local'
  }

  const locationUrl = window.location.href
  const regexpUrl = /^([^.]+\/)(\b((?!insights\b)[\s\S])+)/
  const isRegexpUrlValid = regexpUrl.test(locationUrl)

  if (isRegexpUrlValid) {
    const envRegexp = regexpUrl.exec(locationUrl)

    switch (envRegexp?.[2]) {
      case 'staging-':
      case 'staging.':
        return 'staging'

      case 'local.':
        return 'local'

      case 'dev-':
      case 'dev.':
        return 'development'

      default:
        if (envRegexp?.[2].includes('testprod')) {
          return 'staging'
        }

        return 'test'
    }
  }

  return 'production'
}

export default getEnvFromLocation
